import BaseController from './BaseController'
import Scrollbar from 'smooth-scrollbar'
import Parallax from '../modules/Parallax';
import ParallaxBlock from '../modules/ParallaxBlock';
import VideoPlayer from '../modules/VideoPlayer'

export default class HomeController extends BaseController {

    init() {
        this.header = document.querySelector('.header')
        if (window.innerWidth > 600) {
            this.initScrollbar()
        }

        this.options = {
            damping: 0.1,
            thumbMinSize: 20,
        }

        this.dones = []

        this.mainVideo = document.querySelector('.background__videoPreview');

        // MediaSource
        if (screen.width > 700) {
            this.mainVideo.innerHTML = "<source type='video/mp4' src='" + videoPreviewDesktop + "' />";
        } else {
            this.mainVideo.innerHTML = "<source type='video/mp4' src='" + videoPreviewMobile + "' />";
        }

        this.$ = {
            menuItems: document.querySelectorAll('.menu-item'),
            scrollbar: document.querySelector('#my-scrollbar'),
            videoLight: document.querySelector('.background'),
            homeWindow: document.querySelector('.homeWindow'),
            playButton: document.querySelector('.content__play'),
            videoQuit: document.querySelector('.video__quit'),
            planningLive: document.querySelector('.planning-live'),
            buttonsSvg: document.querySelectorAll('.mainButton--svgBorder'),
            videoHeavy: {
                backgroundVideo: document.querySelector('.background__video'),
            },
            global: {
                img: document.querySelectorAll('.homeArticle__introImageContainer'),
                title: document.querySelectorAll('.homeArticle__introTitle, .homeArticle__introSubtitle'),
                background: document.querySelectorAll('.homeArticle__introBackground'),
                text: document.querySelectorAll('.homeArticle__content h2, .homeArticle__content p')
            },
            window2: {
                window: document.querySelector('.window-2'),
            },
            window3: {
                window: document.querySelector('.window-3'),
                title: document.querySelector('.homeDescriptionTitle'),
                descriptionItems: document.querySelectorAll('.homeDescription__information'),
                imageContainer: document.querySelector('.homeDescription__image-wrapper'),
                image: document.querySelector('.homeDescription__image'),
                description: document.querySelector('.homeDescription'),
                descriptionText: document.querySelector('.homeDescription__text'),
                descriptionTextSpan: document.querySelector('.homeDescription__text span'),
                container: document.querySelector('.homeDescriptionContainer')
            },
            window4: {
                window: document.querySelector('.window-4'),
                articleHeader: document.querySelector('.homeArticle__intro'),
                articleBackground: document.querySelector('.homeArticle--1 .homeArticle__introBackground'),
                articleTitle: document.querySelector('.homeArticle__introTitle'),
                articleSubTitle: document.querySelector('.homeArticle__introSubtitle'),
                articleImg: document.querySelector('.homeArticle__introImage'),
                articleImgContainer: document.querySelector('.window-4 .homeArticle__introImageContainer'),
                articleContent: document.querySelector('.homeArticle--1 .homeArticle__content'),
            },
            window5: {
                window: document.querySelector('.homeArticle--2'),
                articleSubTitles: document.querySelectorAll('.homeArticle__introContent .homeArticle__subtitle'),
                articleSubTitleItem: document.querySelectorAll('.homeArticle__subtitleItem'),
                articleIntroContent: document.querySelector('.homeArticle--2 .homeArticle__introContent'),
                articleIntroBackground: document.querySelector('.homeArticle--2 .homeArticle__intro .homeArticle__introBackground'),
                articleBackground: document.querySelector('.homeArticle--2 .homeArticle__introBackground'),
                articleTitle: document.querySelector('.homeArticle--2 .homeArticle__introTitle'),
                articleSubTitle: document.querySelector('.homeArticle--2 .homeArticle__introSubtitle'),
                articleImg: document.querySelector('.homeArticle--2 .homeArticle__introImage'),
                articleImgContainer: document.querySelector('.homeArticle--2 .homeArticle__introImageContainer'),
                articleIntro: document.querySelector('.homeArticle--2 .homeArticle__intro'),
            },
            window6: {
                window: document.querySelector('.homeArticle--3'),
                articleBackground: document.querySelector('.homeArticle--3 .homeArticle__introBackground'),
                articleImgContainer: document.querySelector('.homeArticle--3 .homeArticle__introImageContainer'),
                articleImg: document.querySelector('.homeArticle--3 .homeArticle__introImage'),
                articleTitle: document.querySelector('.homeArticle--3 .homeArticle__introTitle'),
                articleSubTitle: document.querySelector('.homeArticle--3 .homeArticle__introSubtitle'),
            },
            hipster: document.querySelector('.hipster')
        }

        this.timeline = {
            window3: new TimelineMax(),
            window4: new TimelineMax(),
            window5: new TimelineMax(),
            window6: new TimelineMax(),
        }

        this.videoHeavyIsTriggered = false
        this.window2Animated = false
        this.window3Animated = false
        this.hipsterIsAnimated = false
        this.descSpanIsHovered = false

        this.doneElements = []

        // new Parallax('background__img', 1, true)

        // this.scrollbar = Scrollbar.init(this.$.scrollbar, this.options)

        this.video = {
            timeline: new TimelineMax(),
            $video: document.querySelector('.background__video .videoPlayer__video'),
        }

        this.imageWindow3 = this.$.window3.imageContainer.getBoundingClientRect();
        this.containerWindow3 = this.$.window3.container.getBoundingClientRect();
        this.textBounds = this.$.window3.descriptionText.getBoundingClientRect();
        this.$.window3.descriptionTextSpan.style.width = `${this.textBounds.width}px`
        this.$.window3.imageContainer.classList.add('isClose')



        this.deltaY = 0

        this.offsetY = {
            window3: 0,
            window4: 0,
            window5: 0,
            window6: 0,
        }

        this._getGallery()
        this.slider()
        this.listeners()
        this.touchmoves()
        this.entry()

        this.mouse = {
            x: 0,
            y: 0,
        }

        this.once = {
            window3: {
                one: true,
                two: true,
            },
            window4: true,
            window5: true,
            window6: true,
        }

        this.video.timeline
            .to(this.$.videoLight, .3, { left: 0, right: 0, top: 0, bottom: 0 }, 'openVideo')
            // .to(this.$.videoLight, .3, { left: '50%', x: '-50%', top: '50%', y: '-50%', width: '100vw', height: '100vh' }, 'openVideo')
            .to('.background', .3, { height: '100%' }, 'openVideo')
            .to('.cursor', .3, { opacity: 0 }, 'openVideo')
            .to('.content__quoteContainer', .3, { scale: 1.1, opacity: 0 }, 'openVideo')
            .to('.content__play', .3, { scale: 1.1, opacity: 0 }, 'openVideo')
            .to('.content__quote--subtitle', .3, { scale: 1.1, opacity: 0 }, 'openVideo')
            .to('.background__img', .3, { opacity: 0, pointerEvents: 'none' }, 'openVideo')
            .to('.content', .3, { pointerEvents: 'none' }, 'openVideo')
            .to('.video__quit', .3, { opacity: 1 }, 'openVideo')
            .to('.header', .3, { opacity: 0 }, 'openVideo')
            .to(document.body, .3, { cursor: 'none' }, 'openVideo')
            .to('.planning-live', .3, { opacity: 0, pointerEvents: 'none' }, 'openVideo')

        this.video.timeline.pause()

        //Parallax
        if (window.innerWidth > 600) {
            this.parallaxBlock = new ParallaxBlock()
        }

        if (window.innerWidth > 600) {
            this.scrollbar.addListener((event) => {
                // Set delta.x or delta.y if isMobile or not
                this.deltaY = event.offset.y

                this.closeVideo()

                if (this.$.planningLive) {
                    this.deltaY >= 50 ? this.$.planningLive.classList.add('active') : this.$.planningLive.classList.remove('active')
                }

                // Button Svg Border
                for (const $button of this.$.buttonsSvg) {
                    if (this.isOnWindow($button).isOnWindow) {
                        TweenMax.to($button.querySelector('svg'), .8, {
                            strokeDashoffset: 0,
                            ease: Power1.easeOut,
                            delay: 0.5
                        })

                        if ($button.querySelector('span')) {
                            TweenMax.to($button.querySelector('span'), .8, {
                                opacity: 1,
                                ease: Power1.easeOut,
                                delay: 0.5
                            })
                        }
                    }
                }

                // Parallax
                this.parallaxBlock.updateElements()


                // If window2.articleIntro is on window
                if (this.$.window2.window && this.isOnWindow(this.$.window2.window).isOnWindow) {
                    if (!this.window2Animated) {
                        this.window2Animated = true
                        this.revealWindow2()
                        const eventsImg = document.querySelectorAll('.event__parallax img')
                        eventsImg.forEach(eventImg => {
                            const dataSrc = eventImg.getAttribute('data-lazy-src')
                            eventImg.setAttribute('src', dataSrc)
                        })
                    }
                }

                // If window3.articleIntro is on window
                if (this.isOnWindow(this.$.window3.window).isOnWindow) {

                    this.scrollXItems(this.$.window3.descriptionItems, this.$.window3.window)
                    if (!this.window3Animated) {
                        this.window3Animated = true
                        this.revealWindow3()
                    }
                }

                // If window5.articleIntro is on window
                if (this.isOnWindow(this.$.window5.articleIntro).isOnWindow) {

                    this.scrollXItems(this.$.window5.articleSubTitleItem, this.$.window5.articleIntro)
                }


                if (this.isOnWindow(this.$.hipster).isOnWindow) {

                    // Hipster reveal
                    if (!this.hipsterIsAnimated) {
                        const height = this.$.hipster.querySelector('.hipster__img').clientHeight
                        this.hipsterIsAnimated = true
                        TweenMax.fromTo(this.$.hipster.querySelector('.hipster__container'), 0.5, {
                            height: '0',
                            y: '50px',
                            ease: Expo.easeOut
                        }, {
                            height: height,
                            y: '0px'
                        })
                        TweenMax.to(this.$.hipster.querySelector('.homeArticle__noiseImage'), 1, {
                            opacity: 0,
                            ease: Expo.easeOut
                        })
                    }
                }

                // Global animations
                for (let i = 0; i < this.$.global.img.length; i++) {
                    if (this.isOnWindow(this.$.global.img[i]).isOnWindow) {
                        this._handleEntries(this.$.global.img[i], 'from', { height: '0%', y: '100px', ease: Expo.easeOut, delay: .5 }, 1.5)
                        this._handleEntries(this.$.global.img[i].querySelector('.homeArticle__introImageParallax'), 'from', { y: '50px', ease: Expo.easeOut, delay: .5 }, 1.5)
                        this._handleEntries(this.$.global.img[i].querySelector('.homeArticle__noiseImage'), 'to', { opacity: 0, ease: Expo.easeOut, delay: .5 }, 2)
                    }
                }

                for (let i = 0; i < this.$.global.title.length; i++) {
                    if (this.isOnWindow(this.$.global.title[i]).isOnWindow) {
                        this._handleEntries(this.$.global.title[i], 'from', { y: '100%', x: '-10px', skewX: '-15deg', ease: Expo.easeOut, delay: .2 }, 2)
                    }
                }

                for (let i = 0; i < this.$.global.background.length; i++) {
                    if (this.isOnWindow(this.$.global.background[i]).isOnWindow) {
                        this._handleEntries(this.$.global.background[i], 'from', { scaleX: 0, ease: Expo.easeOut, delay: .2 }, 2)
                    }
                }

                for (let i = 0; i < this.$.global.text.length; i++) {
                    if (this.isOnWindow(this.$.global.text[i]).isOnWindow) {
                        this._handleEntries(this.$.global.text[i], 'from', { y: '50%', opacity: 0, ease: Expo.easeOut, delay: .2 }, 1.8)
                    }
                }


                // Hide block if is mobile and position cursor in bloc footer
                // console.log('Width : '+ window.innerWidth +' - Scroll footer : ' + document.querySelector('.footer').offsetTop +' - position : ' + this.deltaY);
                if (window.innerWidth < 600) {
                    if (typeof (this.$.planningLive) != 'undefined' && this.$.planningLive != null) {
                        if (this.deltaY > document.querySelector('.footer').offsetTop) {
                            this.$.planningLive.style.opacity = "0"
                        } else {
                            this.$.planningLive.style.opacity = "1"
                        }
                    }
                }
            })
        }

        this.testTitle = document.querySelector('.homeArticle--1 .homeArticle__intro')
        this.testTitle2 = document.querySelector('.homeArticle__introTitle')
        this.testTitle3 = document.querySelector('.homeArticle__introSubtitle')
        this.testTitle.style.transformOrigin = 'right'
        this.testTitle2.style.transformOrigin = 'right'
        this.testTitle3.style.transformOrigin = 'right'
        this.currentPixel = this.deltaY

        if (window.innerWidth > 600) {
            this.initScrollbar()
        }

        this.skewEffect()
        this.revealAnimate()
        this.initGrain()


        // Hover homeDescription
        this.videos = document.querySelectorAll('.homeDescription__video video')
        this.videoContainer = document.querySelector('.homeDescription__video')
        this.homeDescContainer = document.querySelector('.homeDescriptionContainer')

        // if (window.innerWidth > 600) {
        //     this.bindHomeDescription()
        // }


        this.content_event_click()
    }

    content_event_click() {
        const content_event_click = document.querySelectorAll('.content-event-click')
        const popup_content_backgrb = document.querySelector('#popup-content .backgrb')
        const popup_content_details__box1 = document.querySelector('#popup-content #details__box1')

        for (const event_element of content_event_click) {
            event_element.addEventListener('click', function (event) {

                document.querySelector('#popup-content .attachment-full').setAttribute('src', event_element.getAttribute("data-popup-image_url"))
                document.querySelector('#popup-content .details-event__name').innerHTML = event_element.getAttribute("data-popup-titre_evenement")
                document.querySelector('#popup-content .details-event__date').innerHTML = event_element.getAttribute("data-popup-date")
                document.querySelector('#popup-content .details-event__time').innerHTML = event_element.getAttribute("data-popup-heure")
                document.querySelector('#popup-content .details__plus').innerHTML = event_element.getAttribute("data-popup-description")
                document.querySelector('#popup-content #myBtn').setAttribute('onclick', "window.open('" + event_element.getAttribute("data-popup-event_link") + "', '_blank');")
                document.querySelector('#popup-content #myBtn').innerHTML = event_element.getAttribute("data-popup-text_event_link")
                document.querySelector('#popup-content .details__more').style.backgroundColor = event_element.getAttribute("data-popup-couleur_popup")



                if (event_element.getAttribute("data-popup-target_blank") == 1) {
                    document.querySelector('#popup-content #myBtn').setAttribute('target', '_blank')
                } else {
                    document.querySelector('#popup-content #myBtn').removeAttribute('target')
                }

                if (event_element.getAttribute("data-popup-show_event_link") == 'oui') {
                    document.querySelector('#popup-content #myBtn').style.display = 'inline-block'
                } else {
                    document.querySelector('#popup-content #myBtn').style.display = 'none'
                }

                popup_content_backgrb.style.display = 'block'
                popup_content_details__box1.style.display = 'block'
            })
        }
    }

    // bindHomeDescription() {
    //     const spanLabel = document.querySelectorAll('.homeDescription__information')
    //     spanLabel.forEach((span, index) => {
    //         span.addEventListener('mousemove', event => this.bindMouseMoveHomeDescription(event, index))
    //         span.addEventListener('mouseleave', event => this.bindMouseLeaveHomeDescription())
    //     })
    // }

    bindMouseMoveHomeDescription(event, i) {
        if (!this.descSpanIsHovered) {
            TweenMax.to(this.videoContainer, 1.5, {
                height: '130px',
                ease: Expo.easeOut
            })

            this.videos.forEach(video => {
                video.style.display = 'none'
            })

            this.videos[i].style.display = 'block'
            this.videos[i].currentTime = 0
            this.videos[i].play()

            this.descSpanIsHovered = true
        }

        this.videoContainer.style.left = `${event.clientX}px`
        this.videoContainer.style.top = `${event.clientY - this.$.window3.window.offsetTop - getComputedStyle(document.querySelector('.scroll-content')).transform.split([','], 6)[5].slice(1, -1)}px`
    }

    bindMouseLeaveHomeDescription() {
        TweenMax.to(this.videoContainer, 0, {
            height: '0px',
        })

        this.descSpanIsHovered = false
    }

    revealWindow2() {
        const timeline = new TimelineMax({ delay: .8 })
        const timelineEven = new TimelineMax({ delay: .95 })

        timeline
            .to('.slick-track .slick-slide:nth-child(odd) .event__noise', 2, {
                opacity: 0,
                ease: Expo.easeOut
            },
                'start'
            )
            .from('.slick-track .slick-slide:nth-child(odd) .event__parallax', 1.5, {
                y: '60px',
                ease: Expo.easeOut
            },
                'start'
            )
            .from('.slick-track .slick-slide:nth-child(odd) .eventTitle span', 1.5, {
                y: '100%',
                x: '-10px',
                skewX: '-15deg',
                ease: Expo.easeOut
            },
                'start'
            )
            .fromTo('.slick-track .slick-slide:nth-child(odd) .event__titleBackground', 1.5, {
                width: '0',
            }, {
                width: '100%',
                ease: Expo.easeOut
            },
                'start+=0.3'
            )
            .from('.slick-track .slick-slide:nth-child(odd) .event__title span', 1.5, {
                y: '100%',
                x: '-10px',
                skewX: '-15deg',
                ease: Expo.easeOut
            },
                'start+=0.5'
            )
            .from('.slick-track .slick-slide:nth-child(odd) .event__day, .event__hour', 1.5, {
                x: '-10px',
                ease: Expo.easeOut
            },
                'start+=0.5'
            )
            .from('.slick-next', 1.5, {
                x: '20px',
                opacity: 0,
                ease: Expo.easeOut
            },
                'start+=0.8'
            )

        timelineEven
            .to('.slick-track .slick-slide:nth-child(even) .event__noise', 2, {
                opacity: 0,
                ease: Expo.easeOut
            },
                'start'
            )
            .from('.slick-track .slick-slide:nth-child(even) .event__parallax', 1.5, {
                y: '60px',
                ease: Expo.easeOut
            },
                'start'
            )
            .from('.slick-track .slick-slide:nth-child(even) .eventTitle span', 1.5, {
                y: '100%',
                x: '-10px',
                skewX: '-15deg',
                ease: Expo.easeOut
            },
                'start'
            )
            .fromTo('.slick-track .slick-slide:nth-child(even) .event__titleBackground', 1.5, {
                width: '0',
            }, {
                width: '100%',
                ease: Expo.easeOut
            },
                'start+=0.3'
            )
            .from('.slick-track .slick-slide:nth-child(even) .event__title span', 1.5, {
                y: '100%',
                x: '-10px',
                skewX: '-15deg',
                ease: Expo.easeOut
            },
                'start+=0.5'
            )
            .from('.slick-track .slick-slide:nth-child(even) .event__day, .event__hour', 1.5, {
                y: '100%',
                opacity: 0,
                x: '-10px',
                ease: Expo.easeOut
            },
                'start+=0.5'
            )

        timeline.play()
        timelineEven.play()
    }

    revealWindow3() {
        const timeline = new TimelineMax({ delay: .8 })

        timeline
            .fromTo('.homeDescriptionTitle', 1, {
                opacity: 0,
            }, {
                opacity: 1,
                ease: Circ.easeOut
            }, 'start')
            .fromTo('.homeDescription__text', 1, {
                opacity: 0,
            }, {
                opacity: 1,
                ease: Circ.easeOut
            }, 'start')


        timeline.play()
    }

    revealAnimate() {
        const $quote = document.querySelector('.content__quote--title')
        const $quoteLines = new SplitText($quote, { type: 'lines' })
        const $quoteLineText = []
        for (const $line of $quoteLines.lines) {
            const $text = document.createElement('div')
            const text = $line.innerText
            $line.innerText = ''
            $line.appendChild($text)
            $text.innerText = text
            $line.style.overflow = 'hidden'
            $quoteLineText.push($text)
        }



        const timeline = new TimelineMax({
            delay: .8,
            onComplete: () => {
                document.querySelector('.background__videoPreview').play()
            }
        })
        if (window.innerWidth > 600) {


            const bgHeight = document.querySelector('.window-1 .background').clientHeight

            timeline
                .fromTo('.window-1 .background', 1, {
                    height: '0',
                    y: '100px',
                    ease: Expo.easeOut
                }, {
                    height: bgHeight >= 400 ? bgHeight : 400,
                    y: 0
                },
                    'homeLoading'
                )
                .from('.window-1 .background__previewContainer', 1.2, {
                    y: '50px',
                    ease: CustomEase.create("custom", "M0,0 C0.305,0 -0.02,1.126 1,1.126")
                },
                    'homeLoading'
                )
                .to(this.$.videoLight.querySelector('.homeArticle__noiseImage'), 1.2, {
                    opacity: 0,
                    ease: CustomEase.create("custom", "M0,0 C0.305,0 -0.02,1.126 1,1.126")
                },
                    'homeLoading'
                )
                .fromTo('.window-1 .background .background__img', 1.5, {
                    y: '300px',
                    ease: CustomEase.create("custom", "M0,0 C0.305,0 -0.02,1.126 1,1.126")
                }, {
                    y: '0px',
                },
                    'homeLoading'
                )
                .staggerFrom($quoteLineText, .8, {
                    y: '100%',
                    x: '-10px',
                    skewX: '-15deg',
                    ease: Circ.easeOut
                }, .16, 'homeLoading+=.4')
                .from('.content__quote--subtitle', .6, {
                    y: '180%',
                    x: '-10px',
                    skewX: '-15deg',
                    ease: Circ.easeOut
                }, 'homeLoading+=.62')
                .to('.content__play svg > rect', .8, {
                    strokeDashoffset: 0,
                    ease: Power1.easeOut
                }, 'homeLoading+=.82')
                .from('.content__play .triangle', .5, {
                    opacity: 0,
                    x: '5px',
                    ease: Power1.easeOut
                }, 'homeLoading+=.82')
        }
        if (document.querySelector('.planning-live--svgBorder svg') !== null) {
            console.log("in")
            timeline.add(
                TweenMax.fromTo('.planning-live__dot, .planning-live__text', .8, {
                    opacity: 0,
                    ease: Power1.easeOut
                }, {
                    opacity: 1
                }, 'homeLoading+=.4')
            )
            timeline.add(
                TweenMax.to(document.querySelector('.planning-live--svgBorder svg'), .8, {
                    strokeDashoffset: 0,
                    ease: Power1.easeOut
                }, 'homeLoading+=.4')
            )
        }
    }

    scrollXItems(items, parentElement) {
        const deltaY = this.isOnWindow(parentElement).offsetY

        // translateX subtitle item on scroll
        for (const [i, item] of items.entries()) {
            item.style.transform = `translateX(${deltaY / (10 * (i + 1))}px)`
        }
    }

    skewEffect() {
        const newPixel = this.deltaY

        const diff = newPixel - this.currentPixel

        const speed = diff * 0.1
        const speed2 = diff * 0.3

        // if(speed < 15 && speed > -15) this.testTitle.style.transform = `skewY(${-speed}deg)`
        // if(speed < 15 && speed > -15) this.testTitle2.style.transform = `skewY(${-speed2}deg)`
        // if(speed < 15 && speed > -15) this.testTitle3.style.transform = `skewY(${-speed2}deg)`

        this.currentPixel = newPixel

        // setTimeout(() => { this.skewEffect() }, 30)
        window.requestAnimationFrame(() => {
            this.skewEffect()
        })
    }
    check(elem) {

        for (const done of this.dones) {
            if (elem == done) {
                return false
            } else {
                this.dones.push(elem)
                return true
            }
        }
        this.dones.push(elem)
        return true
    }
    window3Entries() {
        if (this.isOnWindow(this.$.window3.title).isOnWindow && this.check(this.$.window3.title)) {

            // TweenMax.to(this.$.window3.title, .3, { opacity: 1 }, 1)
            // this.letterByLetter(this.$.window3.title, 1, this.timeline.window3, '')

            // this.once.window3.one = false
        }

        this.offsetY.window3 = this.deltaY - this.$.window3.window.offsetTop

        // // translateX subtitle item on scroll
        // for(const [i, descriptionItem] of this.$.window3.descriptionItems.entries())
        // {
        //   descriptionItem.style.transform = `translateX(${this.offsetY.window3 / (10 * (i + 1))}px)`
        // }

        if ( /*this.deltaY >= this.$.window3.window.offsetTop - (this.$.window3.window.offsetHeight / 2) && */ this.once.window3.two) {
            this.timeline.window3
                .to(this.$.window3.window, .5, { scaleX: 1 })
                .from(this.$.window3.description, .5, { opacity: 0, y: '50px' }, 'skew')
                .from(this.$.window3.title, .5, { opacity: 0, y: '50px' }, 'skew+=.3')
            // .from(this.$.window3.description, 1, { y: 200, skewY: '-10deg', ease: Expo.easeOut }, 'skew')
            // this.letterByLetter(this.$.window3.title, 1, this.timeline.window3)

            this.once.window3.two = false
        }
    }

    _mouseFollowWindow3(event) {
        let imageAnimationContainerBounds = this.imageWindow3
        this.mouse.x = event.clientX
        this.mouse.y = event.clientY - this.$.window3.window.getBoundingClientRect().y

        TweenMax.to(this.$.window3.imageContainer, 0.7, { x: this.mouse.x - (imageAnimationContainerBounds.width / 2), y: this.mouse.y - (imageAnimationContainerBounds.height / 2), ease: Power2.easeInCubic })
    }

    _textAnimation() {
        let imageAnimationContainerBounds = this.imageWindow3
        this.$.window3.container.addEventListener('mousemove', () => {
            let positionMouseX = event.clientX - this.textBounds.left,
                minPositionPathX = positionMouseX - imageAnimationContainerBounds.width / 2,
                maxPositionPathX = positionMouseX + imageAnimationContainerBounds.width / 2;

            TweenMax.to(this.$.window3.descriptionTextSpan, 0.7, { webkitClipPath: `polygon(${minPositionPathX}px 0, ${maxPositionPathX}px 0, ${maxPositionPathX}px 100%, ${minPositionPathX}px 100%)`, ease: Power2.easeInCubic });
            TweenMax.to(this.$.window3.descriptionTextSpan, 0.7, { clipPath: `polygon(${minPositionPathX}px 0, ${maxPositionPathX}px 0, ${maxPositionPathX}px 100%, ${minPositionPathX}px 100%)`, ease: Power2.easeInCubic });

        });
    }

    window4Entries() {
        this.offsetY.window4 = this.deltaY - this.$.window4.window.offsetTop

        this.$.window4.articleTitle.style.transform = `translateY(${-this.offsetY.window4 * 0.1}px)`
        this.$.window4.articleSubTitle.style.transform = `translateY(${-this.offsetY.window4 * 0.1}px)`
        this.$.window4.articleImg.style.transform = `translateY(${-this.offsetY.window4 / 20}px)`
        this.$.window4.articleContent.style.transform = `translateY(${-this.offsetY.window4 / 14}px)`
        // this.$.window4.articleImgContainer.style.transform = `scale(${1 + ((this.offsetY.window4 / this.$.window4.articleContent.offsetHeight) / 10) })`

        TweenMax.from(this.$.window4.articleImgContainer, .5, { scaleX: .5 })

        // if(this.deltaY >= this.$.window4.window.offsetTop - (this.$.window4.window.offsetHeight / 2) && this.once.window4)
        // {
        //   this.timeline.window4
        //   .to(this.$.window4.articleBackground, 1, { scaleX: 1 }, "window4")
        //   if(window.innerWidth >= 900)
        //   {
        //   }
        //   else
        //   {
        //     TweenMax.from(this.$.window4.articleImgContainer, 1, { width: '0' }, "window4+=.6")
        //   }

        //   this.letterByLetter(this.$.window4.articleTitle, 0, this.timeline.window4, "window4+=.8")

        //   this.once.window4 = false
        // }
    }
    window5Entries() {
        this.offsetY.window5 = this.deltaY - (this.$.window5.window.offsetTop - this.$.window5.window.offsetHeight)

        this.$.window5.articleIntroContent.style.transform = `translateY(${-this.offsetY.window5 * .05}px)`
        this.$.window5.articleTitle.style.transform = `translateY(${-this.offsetY.window5 / 60}px)`
        this.$.window5.articleSubTitle.style.transform = `translateY(${-this.offsetY.window5 / 40}px)`
        this.$.window5.articleImg.style.transform = `translateY(${-this.offsetY.window5 / 50}px)`

        if (this.once.window5) {
            this.timeline.window5
                .to(this.$.window5.articleIntroBackground, 1, { scaleX: 1 }, "window5")
                .to(this.$.window5.articleBackground, 1, { scaleX: 1 }, "window5+=.3")
                .to(this.$.window5.articleImgContainer, 1, { width: '100%' }, "window5+=.6")

            this.letterByLetter(this.$.window5.articleTitle, 0, this.timeline.window5, "window5+=1")

            for (const articleSubtitle of this.$.window5.articleSubTitles) {
                this.letterByLetter(articleSubtitle, 0, this.timeline.window5, "window5+=.8")
            }
            for (const [i, articleSubTitleItem] of this.$.window5.articleSubTitleItem.entries()) {
                this.timeline.window5.from(articleSubTitleItem, .3, { opacity: 0 }, "window5+=1.4")
            }
        }

        this.once.window5 = false
    }
    window6Entries() {
        this.offsetY.window6 = this.deltaY - (this.$.window6.window.offsetTop - this.$.window6.window.offsetHeight)

        this.$.window6.articleTitle.style.transform = `translateY(${-this.offsetY.window6 / 10}px)`
        this.$.window6.articleSubTitle.style.transform = `translateY(${-this.offsetY.window6 / 10}px)`
        this.$.window6.articleImg.style.transform = `translateY(${-this.offsetY.window6 / 20}px)`

        if (this.deltaY >= this.$.window6.window.offsetTop - (this.$.window6.window.offsetHeight / 2) && this.once.window6) {
            this.timeline.window6
                .to(this.$.window6.articleBackground, 1, { scaleX: 1 }, "window6")
                .to(this.$.window6.articleImgContainer, 1, { width: '60%' }, "window6+=.6")

            this.letterByLetter(this.$.window6.articleTitle, 0, this.timeline.window6, "window6+=1")

            this.once.window6 = false
        }
    }
    _getGallery() {
        if (window.innerWidth < 769) return
        this.gallery = this.$.window3.description.dataset.gallery.split(',')
        this._setGallery()
    }

    _setGallery() {
        this.$.window3.image.src = this.gallery[0]
        this.galleryIndex = 1
        setInterval(() => {
            if (this.galleryIndex === this.gallery.length) {
                this.galleryIndex = 0
            }
            this.$.window3.image.src = this.gallery[this.galleryIndex]

            this.galleryIndex++
        }, 2000)
    }

    entry() {

    }

    listeners() {
        // const $planningLive = document.querySelector('.planning-live')
        // window.addEventListener('scroll', () => {
        //   this.deltaY >= 50 ? $planningLive.classList.add('active') : $planningLive.classList.remove('active')
        // })

        if (window.innerWidth <= 600) {
            window.addEventListener('scroll', () => {
                if (this.$.window2.window && this.isOnWindow(this.$.window2.window).isOnWindow) {
                    if (!this.window2Animated) {
                        this.window2Animated = true
                        const eventsImg = document.querySelectorAll('.event__parallax img')
                        eventsImg.forEach(eventImg => {
                            const dataSrc = eventImg.getAttribute('data-lazy-src')
                            eventImg.setAttribute('src', dataSrc)
                        })
                    }
                }
            })
        }

        const $planningTimes = document.querySelectorAll('.menu__time')
        for (const $time of $planningTimes) {
            $time.style.left = `${Math.floor(Math.random() * ($time.parentNode.clientWidth / 2))}px`
        }

        const $menuLive = document.querySelector('.menu-live')

        if (this.$.planningLive) {
            this.$.planningLive.addEventListener('click', () => {
                if ($menuLive) {
                    TweenMax.to($menuLive, .4, { x: '-100%', ease: Power1.easeOut })
                }
            })
        }

        if ($menuLive) {
            const $quit = $menuLive.querySelector('.menu-live__quit')
            $quit.addEventListener('click', () => {
                TweenMax.to($menuLive, .4, { x: '0%', ease: Power1.easeOut })
            })
        }

        if ($menuLive) {
            const $quit_activity = $menuLive.querySelector('.menu-live__activity')
            $quit_activity.addEventListener('click', () => {
                TweenMax.to($menuLive, .4, { x: '0%', ease: Power1.easeOut })
            })
        }




        window.addEventListener('click', (event) => {
            let isClickable = false
            for (const $elem of event.path) {
                if ($elem == $menuLive || $elem == this.$.planningLive) {
                    isClickable = true
                }
            }
            if (!isClickable) {
                if ($menuLive) {
                    TweenMax.to($menuLive, .4, { x: '0%', ease: Power1.easeOut })
                }
            }
        })

        this.$.homeWindow.addEventListener('mousemove', (event) => {
            this.mouse.x = event.clientX
            this.mouse.y = event.clientY
            this.$.videoQuit.style.transform = `translateX(calc(-50% + ${this.mouse.x}px)) translateY(calc(-50% + ${this.mouse.y}px))`
        })

        this.$.window3.container.addEventListener('mousemove', (event) => this._mouseFollowWindow3(event));

        this.$.window3.container.addEventListener('mouseenter', () => {
            console.log('enter')
            this.$.window3.imageContainer.classList.remove('isClose')

            this._textAnimation()
        });
        this.$.window3.container.addEventListener('mouseleave', () => {
            this.$.window3.imageContainer.classList.add('isClose');
        });

        this.$.playButton.addEventListener('click', () => {
            this.openVideo()
            this.video.$video.addEventListener('click', () => {
                this.closeVideo()
            })

            // TweenMax.to('.header', .3, { scale: 1.2, opacity: 0 })
        })


    }
    openVideo() {
        // this.scrollbar.destroy()
        if (!this.videoHeavyIsTriggered) {
            this.video.player = new VideoPlayer('background__video', this.$.videoHeavy.backgroundVideo.dataset.src, 'La montgolfiere')
            this.video.$video = document.querySelector('.background__video .videoPlayer__video')

            // iOS native support
            this.video.$video.addEventListener('webkitendfullscreen', () => {
                this.closeVideo()
            }, false)

            this.videoHeavyIsTriggered = true
        }
        document.querySelector('body').classList.add('js-video-opened')
        this.video.player.playVideo()
        this.video.timeline.play()
    }
    closeVideo() {
        // this.scrollbar = Scrollbar.init(this.$.scrollbar, this.options)
        if (this.videoHeavyIsTriggered) {
            document.querySelector('body').classList.remove('js-video-opened')
            this.video.player.pauseVideo()
            this.video.timeline.reverse()
        }
    }

    slider() {
        let numberSlide
        if (window.innerWidth < 769) {
            numberSlide = 1
        } else {
            numberSlide = 3
        }
        $(document).ready(function () {
            $('.slider__slides').slick({
                infinite: false,
                dots: true,
                slidesToShow: numberSlide,
                slidesToScroll: numberSlide,
                swipeToSlide: true,
                mobileFirst: true,
                variableWidth: true,
                appendArrows: '.slider__arrows-wrapper',
            })
            let $progressBar = $('.slider__progress');
            let $slider = $('.slider__slides');
            let isSliding;
            $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                isSliding = true;
                let number = slick.$dots[0].childElementCount - 1;
                let calc = ((nextSlide) / (number)) * 100;
                $progressBar
                    .css('background-size', calc + '% 100%')
                    .attr('aria-valuenow', calc);

            });
            $slider.on('afterChange', function (event, slick, currentSlide, nextSlide) {
                isSliding = false
            });

            $slider.on('click', (event) => {
                if (isSliding) {
                    event.stopImmediatePropagation();
                    event.stopPropagation();
                    event.preventDefault();
                    return;
                }
            });

            $('.homeDescription__image-wrapper-mobile').slick({
                infinite: true,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                swipeToSlide: true,
                mobileFirst: true,
                variableWidth: true,
                appendArrows: '.slider__arrows-wrapper-mobile',
            })
        })
    }

    touchmoves() {
        const $menuLive = document.querySelector('.menu-live')


        let isTouching = false
        let distance = 0
        let start = null

        if ($menuLive) {
            $menuLive.addEventListener('touchstart', (e) => {
                start = e.touches[0].screenX
                isTouching = true
                document.body.classList.add('fixed')
            })
            $menuLive.addEventListener('touchend', (e) => {
                if (distance >= 100) {
                    TweenMax.to($menuLive, .4, { x: '0%', ease: Power1.easeOut })
                } else {
                    TweenMax.to($menuLive, .4, { x: '-100%', ease: Power1.easeOut })
                }
                isTouching = false
                distance = 0
                start = null
                document.body.classList.remove('fixed')
            })
            $menuLive.addEventListener('touchmove', (e) => {
                if (isTouching) {
                    distance = e.touches[0].screenX - start

                    if (distance >= 10) {
                        TweenMax.to($menuLive, .3, { x: `${distance}px`, ease: Power1.easeOut })
                    }
                }
            })
        }
    }

    letterByLetter(_$elem, delay, tween, label = 0) {
        const letters = new SplitText(_$elem, { type: 'chars' })
        tween.staggerFrom(letters.chars, .5, { y: '100%', opacity: 0, ease: Power1.easeOut, delay }, .04, label)
    }

    _isOnce(_element) {
        let isDone = false

        for (let i = 0; i < this.doneElements.length; i++) {
            if (this.doneElements[i] == _element)
                isDone = true
        }

        return isDone
    }

    _handleEntries(_element, _direction, _animation, _duration) {
        if (!this._isOnce(_element)) {
            switch (_direction) {
                case 'from':
                    TweenMax.from(_element, _duration, _animation)
                    break;
                case 'to':
                    TweenMax.to(_element, _duration, _animation)
                    break;
                case 'staggerFrom':
                    TweenMax.staggerFrom(_element, _duration, _animation, .1)
                    break;
            }
        }

        this.doneElements.push(_element)
    }
}